import { useState } from 'react';

import { toast } from 'material-react-toastify';

import Counter from '@/components/Counter/Counter';
import Popup from '@/components/Popup/PopUp/PopUp';
import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';
import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { useHubStore } from '@/lib/store/hubStore';

interface AddSessionModalProps {
  isPopupOpen: boolean;
  closePopup: () => void;
  setAvailableSessions: (sessions: number) => void;
}

const AddSessionModal = ({
  isPopupOpen,
  closePopup,
  setAvailableSessions,
}: AddSessionModalProps) => {
  const user = useHubStore((state) => state.searchUserData);

  const [count, setCount] = useState<number>(1);
  const increment = () => setCount((prev) => prev + 1);
  const decrement = () => setCount((prev) => Math.max(1, prev - 1));

  const handleCreateSessions = async () => {
    closePopup();
    const token = await getAuthToken();
    const success = await hubApi.createSessionsByUserIDHub(
      user.id,
      { quantity: count, source: 'hub' },
      withAuthHeader(token),
    );
    if (success) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setAvailableSessions((prev) => prev + count);
      toast.success(`Sessions in quantity ${count} were successfully added `);
    }
  };

  return (
    <Popup isOpen={isPopupOpen} handleClose={closePopup}>
      <div>
        <Text.Bigger weight="bold">How many sessions need to be added?</Text.Bigger>

        <div className="flex justify-center items-center my-8">
          <Counter count={count} increment={increment} decrement={decrement} />
        </div>

        <div className="flex justify-center items-center gap-2">
          <Button
            prefixIcon={<img alt={'check'} src={'/icons/check.svg'} />}
            label="Add"
            size="s"
            className="!w-24"
            onClick={handleCreateSessions}
          />
          <Button
            prefixIcon={<img alt={'close'} src={'/icons/close_outline.svg'} />}
            label="Cancel"
            variant="transparent"
            onClick={closePopup}
            className="!w-28"
            size="s"
          />
        </div>
      </div>
    </Popup>
  );
};

export default AddSessionModal;
